import { Skeleton } from '@ibsys/kit';
import { FC } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAttribute } from '@/entities/attributes';
import { AttributeForm } from './AttributeForm';

type Props = {
  attributeCode?: string;
  onSuccess?: () => void;
  onUnsavedChange?: (hasUnsaved: boolean) => void;
};

export const AttributeFormSection: FC<Props> = ({ attributeCode, onSuccess, onUnsavedChange }) => {
  const { t } = useTranslation('attributes');
  const { parentStruct: parentStructCode } = useParams<{ id?: string; parentStruct?: string }>();

  const [searchParams] = useSearchParams();
  const isCreateMode = attributeCode === 'create';
  const code = isCreateMode ? undefined : attributeCode;

  // Only pass parent-struct-code if it's not SIMPLE
  const attributeParams =
    parentStructCode && parentStructCode !== 'SIMPLE' ? { 'parent-struct-code': parentStructCode } : undefined;

  const { data: attribute, isLoading } = useAttribute(code, attributeParams);

  if (isLoading) {
    return <Skeleton className="h-full" />;
  }

  if (attribute || isCreateMode) {
    return (
      <AttributeForm
        key={attribute?.code ?? 'create'}
        initial={attribute}
        onSuccess={onSuccess}
        onUnsavedChange={onUnsavedChange}
        searchParams={searchParams}
      />
    );
  }

  return (
    <div className="flex items-center justify-center h-full text-muted-foreground">
      {t('selectAttribute')}
    </div>
  );
};
